var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRussia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flag_of_Russia 1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2900_22813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27 0.5H0V9.5H27V0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27 9.5H0V18.5H27V9.5Z",
    fill: "#D52B1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27 6.5H0V12.5H27V6.5Z",
    fill: "#0039A6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 26,
    height: 17,
    rx: 1.5,
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2900_22813"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 27,
    height: 18,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussia);
export default __webpack_public_path__ + "static/media/russia.3de5bc1e9fd938ccd3e72bb5d5d90e80.svg";
export { ForwardRef as ReactComponent };